var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CMS_CREATE_PATH, CMS_ELIGIBILITY_PATH, CMS_GUEST_ELIGIBILITY_PATH, CMS_GUEST_CREATE_PATH, CMS_REASON_CODES_PATH, CMS_GUEST_REASON_CODES_PATH, } from '../../constants/paths';
import { getHost } from '../../utils/general';
import { apiCMS } from '../axios-client';
/** Assigning serviceMeshUrl directly to bypass local issue where baseUrl in config is being overridden */
/** @see {@link apiCMS} */
var baseurl = getHost();
/** @see {@link ICmsCreateRequest} */
export var CmsCreateCancelApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser ? CMS_CREATE_PATH : CMS_GUEST_CREATE_PATH;
    var config;
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    var updatedLineItems = request.lineItems.map(function (item) { return (__assign(__assign({}, item), { workOrderNumber: item.workOrderNumber === '' ? undefined : item.workOrderNumber })); });
    var updatedRequest = __assign(__assign({}, request), { lineItems: updatedLineItems });
    return apiCMS.post(path, updatedRequest, __assign(__assign({}, config), { baseURL: baseurl }));
};
export var CmsCancelEligibilityApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser
        ? CMS_ELIGIBILITY_PATH
        : CMS_GUEST_ELIGIBILITY_PATH;
    var config;
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    return apiCMS.post(path, request, __assign(__assign({}, config), { baseURL: baseurl }));
};
export var CmsCancellationReasonCodesApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser
        ? CMS_REASON_CODES_PATH
        : CMS_GUEST_REASON_CODES_PATH;
    var config = {};
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    return apiCMS.post(path, request, __assign(__assign({}, config), { baseURL: baseurl }));
};
